import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import categories from '@/mocks/categories';
import ArticleCard from '@/components/base/ArticleCard';

const tabs = [{ slug: 'all', name: '全部甜瓜' }, ...categories.map((c) => ({ slug: c.slug, name: c.name }))];

export default function LatestFeed() {
  const [active, setActive] = useState('all');

  const list = useMemo(() => {
    const base = active === 'all' ? articles : articles.filter((a) => a.category === active);
    return base.slice(0, 6);
  }, [active]);

  return (
    <section id="latest" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8">
        <div>
          <p className="flex items-center gap-2 text-xs tracking-widest text-primary-600">
            <i className="ri-time-line" aria-hidden="true"></i>
            FRESH FEED
          </p>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">最新瓜料</h2>
        </div>

        <div className="flex gap-1 rounded-full border border-background-200 bg-background-100 p-1 overflow-x-auto">
          {tabs.map((t) => (
            <button
              key={t.slug}
              type="button"
              onClick={() => setActive(t.slug)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors cursor-pointer ${
                active === t.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-primary-600'
              }`}
            >
              {t.name}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {list.map((a) => (
          <ArticleCard key={a.id} article={a} />
        ))}
      </div>

      <div className="mt-10 flex justify-center">
        <Link
          to="/fresh"
          className="inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          去瓜田速递看更多
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </section>
  );
}